import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { put } from '../../../redux/api';

type ToggleInternalOrgParams = {
  flag: boolean;
};

async function toggleInternalOrg({ flag }: ToggleInternalOrgParams): Promise<void> {
  await put('/api/organizations/toggle_internal', { flag });
}

/**
 * Hook to toggle the internal organization flag.
 * @param onSuccessCallback - Optional callback to execute after successful toggle
 * @returns Mutation function to toggle internal organization status
 */
export const useToggleInternalOrg = (onSuccessCallback?: () => void) => {
  return useToastedMutation({
    mutationFn: toggleInternalOrg,
    successToastMessage: 'Organization internal status updated successfully',
    errorToastMessage: 'Failed to update is_internal status for organization',
    onSuccess: onSuccessCallback,
  });
};
